export function generateRandomID() {
  const randomNumber = Math.random();
  const numberAsString = randomNumber.toString(36);
  const id = numberAsString.substring(7);

  return id;
}
